import { InvestmentBreakdown } from 'stores/dashboard-store/dashboard-store';
import styles from './beneficiaries.module.scss';
import { Typography } from '@sanlam-glacier/app-common/components';

interface BeneficiaryTooltipProps {
  investmentDetails: InvestmentBreakdown[];
}

const BeneficiaryTooltipContent = ({ investmentDetails }: BeneficiaryTooltipProps) => {
  return (
    <>
      {investmentDetails.map((investment, index) => (
        <div
          data-testid={`beneficiaryInvestmentDetails${index}`}
          className={index == 0 ? '' : styles.investmentBreakdownBorder}
          key={index}
        >
          <div className={styles.text}>
            <Typography
              data-testid={'beneficiaryInvestmentDescription'}
              color={Typography.COLOR.INHERIT}
              variant={Typography.VARIANT.B4}
              weight={Typography.WEIGHT.MEDIUM}
            >
              {investment.number} - {investment.name}
            </Typography>
          </div>
          <div data-testid={'beneficiaryInvestmentRoles'} className={styles.text}>
            <Typography
              color={Typography.COLOR.INHERIT}
              variant={Typography.VARIANT.B4}
              weight={Typography.WEIGHT.NORMAL}
            >
              {'\t'}
              {investment.roles.map((role, index) => (
                <label data-testid={`beneficiaryRoleLabel${index}`} key={role}>
                  {role}
                  {index === investment.roles.length - 1 ? '' : ' | '}
                </label>
              ))}
            </Typography>
          </div>
        </div>
      ))}
    </>
  );
};

export default BeneficiaryTooltipContent;
